import { ModuleWithProviders, NgModule } from '@angular/core';

import { ACTIVE_THEME, ThemeOptions, THEMES } from './symbols';

@NgModule()
export class ThemeModule {
  static forRoot(options: ThemeOptions): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        {
          provide: THEMES,
          useValue: options.themes
        },
        {
          provide: ACTIVE_THEME,
          useValue: options.active
        }
      ]
    };
  }
}
